
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { dialogStyles } from '../Styles/dialogStyles';
import Images from '../Theme/Images';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { ReactSVG } from 'react-svg';
@inject('userStore')
@observer
class Overlay extends React.Component {



    render() {
        const { serverDown } = this.props.userStore;
        const { classes, title, message } = this.props;
        return (
            <Dialog disableBackdropClick={false} disableEscapeKeyDown={true} classes={{ paper: classes.overlayDialog, scrollPaper: classes.overlayBackdrop }} open={serverDown} aria-labelledby="form-dialog-title">

                <DialogContent>
                    <div className={classes.overlay}>
                        <ReactSVG src={Images.serverError} className={classes.overlayError}/> &nbsp;&nbsp;
                        <div >AI Services are down at the moment, please contact Vikram/Amulya to get the services up and running</div>
                    </div>
                </DialogContent>
            </Dialog>
        )
    }
}

Overlay.propTypes = {
    classes: PropTypes.object.isRequired,
    cancelDelete: PropTypes.func.isRequired,
    delete: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired
};
export default withStyles(dialogStyles, { withTheme: true })(withRouter(Overlay));
